import { http, HttpResponse } from "msw";
import { creditAccountsUrl } from "../api/endpoints.js";
import "syf-js-utilities/helpers/generateUUID";
import "syf-js-utilities/typings/HTTPError";
import creditAccountsQueryMock from "./creditAccountsQueryMock.js";
const creditAccountsQueryGetHandler = ({
  hostUrl = void 0
}) => {
  const url = hostUrl ? new URL(creditAccountsUrl, hostUrl).href : creditAccountsUrl;
  return http.get(url, () => {
    const responseData = creditAccountsQueryMock();
    return HttpResponse.json(responseData);
  });
};
export { creditAccountsQueryGetHandler };
//# sourceMappingURL=creditAccountsQuery.msw.js.map
